import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FieldConfig } from "../../../interfaces/field.interface";
import { EnderecoPipe } from "../../../pipes/endereco/endereco";
import { UserProvider } from "src/app/services/user/user";
import { IonicModule, ModalController } from "@ionic/angular";
import { PessoaEditEnderecoPage } from "src/app/pages/pessoa/pessoa-edit-endereco/pessoa-edit-endereco.page";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-input",
  template: `
    <div>
      <ion-item [formGroup]="group" (click)="abrirEndereco()" lines="none">
        <div class="alinhamento-div">
          <label position="stacked" class="custom-label">
            {{ field.label ?? "" | translate }}
            <span
              *ngIf="
                field.validations &&
                field.validations[0] &&
                field.validations[0].name == 'required'
              "
              class="danger"
              >*</span
            >
          </label>
          <ion-textarea
            arial-label=""
            placeholder="{{ field.label ? (field.label | translate) : '' }}"
            [readonly]="true"
            [autoGrow]="false"
            [formControlName]="field.name"
          >
          </ion-textarea>
        </div>
      </ion-item>

      <div class="validation-errors">
        <ng-container *ngFor="let validation of field.validations">
          <div
            class="error-message"
            *ngIf="
              group.get(field.name)?.hasError(validation.name) &&
              (group.get(field.name)?.dirty || group.get(field.name)?.touched)
            "
          >
            {{ "Campo Obrigatório" | translate }}
          </div>
        </ng-container>
      </div>
    </div>
  `,
  styles: [
    `
      .alinhamento-div {
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      ion-textarea {
        --padding-top: 0 !important;
        --padding-bottom: 0 !important;
        font-size: 14px;
        max-width: 100%;
        max-height: 80px;
        padding: 0 !important;
        color: #787486;
        label .label-text-wrapper {
          font-size: 1.3rem;
          color: black;
        }
      }

      ion-item {
        --inner-border-width: 0;
        padding-top: 5px;
        margin: 0 20px;
      }

      .error-message {
        padding: 0px !important;
        font-size: 12px !important;
      }

      .validation-errors {
        margin-left: 35px;
      }

      .custom-label {
        font-size: 15px;
        font-weight: 500;
      }
    `,
  ],
  standalone: true,
  imports: [TranslateModule, IonicModule, ReactiveFormsModule, CommonModule],
})
export class EnderecoComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  private isOpeningEnderecoModal = false;

  constructor(
    public userProvider: UserProvider,
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {}

  async abrirEndereco() {
    if (this.isOpeningEnderecoModal) return;

    this.isOpeningEnderecoModal = true;
    try {
      const login = await this.userProvider.isLoggedin();
      const semSalvar = !login || this.userProvider.isAnonimo();

      const data = {
        endereco: this.field.value,
        fromForm: true,
        semSalvar,
      };

      const modalPage = await this.modalCtrl.create({
        component: PessoaEditEnderecoPage,
        componentProps: data,
      });

      await modalPage.present();

      const { data: modalData } = await modalPage.onDidDismiss();

      if (modalData) {
        this.field.value = modalData;
        const enderecoPipe = new EnderecoPipe();
        const endereco = enderecoPipe.transform(this.field.value);
        this.getFieldControl(this.field.name)?.setValue(endereco);
      }
    } finally {
      setTimeout(() => (this.isOpeningEnderecoModal = false), 300);
    }
  }

  getFieldControl(path: any | string[]) {
    return this.group.get(path as string);
  }
}
